import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';
import TabItem from '../components/_TabItem';

function SearchTabs({ search, settings }) {
	return (
		<nav className="events-listing-filter search-listing-filter">
			<a className="filter_list--dropdown" href="javascript: void(0)">
				Filter
				<svg className="icon"><use xlinkHref="#icon-chevron-down"></use></svg>
			</a>
			<div className="row column">
				<ul className="events-listing-filter__list collapsed">
					{/*
					<TabItem currentSearch={search} type='searchType' search='all' settings={settings}>
						All
					</TabItem>
					<TabItem currentSearch={search} type='searchType' search='media' settings={settings}>
						MEDIA AND EVENTS
					</TabItem>
					<TabItem currentSearch={search} type='searchType' search='technical' settings={settings}>
						TECHNICAL KNOWLEDGE
					</TabItem>
					*/}
				</ul>
			</div>
		</nav>
	);
}
SearchTabs.propTypes = {
    entries: PropTypes.object,
};

const mapStateToProps = state => ({ entries: getEntries(state), search: getSearch(state), filters: getFilters(state), settings: getSettings(state) });

export default connect(mapStateToProps)(SearchTabs);
